import V2Title from '@/common/components/Feedback/V2Title';
import styles from './index.module.less';
import { FC, useEffect, useMemo, useState } from 'react';
import V2Tabs from '@/common/components/Data/V2Tabs';
import { useMethods } from '@lhb/hook';
import V2Table from '@/common/components/Data/V2Table';
import { get } from '@/common/request';
import { gatherMethods, isNotEmptyAny, refactorPermissions } from '@lhb/func';
import IconFont from '@/common/components/IconFont';
import { message } from 'antd';
import { exportFlowData } from '@/common/api/passengerflowcount';
import V2Operate from '@/common/components/Others/V2Operate';
import { V2Confirm } from '@/common/components/Others/V2Confirm';
import { post } from '@/common/components/config-v2';
import { usePageTitle } from '@/common/hook/usePageTitle';

/**
 * @Description 点位详情，机位信息
 */
const MachineInfo: FC<{
  detail, isDemonstrate, onRefresh,
  /** 是否禁用（分享时禁用操作） */
  disabled?: boolean;
}> = ({ detail, isDemonstrate, onRefresh, disabled }) => {
  const [tabItems, setTabItems] = useState<any>([]);
  const [filters, setFilters] = useState<any>({});
  const [activeKey, setActiveKey] = useState('');
  const [deviceInfo, setDeviceInfo] = useState<any>([]);
  const [dynamicColumns, setDynamicColumns] = useState<any>([]);
  const { name: menuName } = usePageTitle();

  const permissions = useMemo(() => {
    let _permissions = detail?.permissions || [];
    if (detail.anaStatus === 3) {
      _permissions = gatherMethods(_permissions, {
        event: 'passengerflowcount:downLoad',
        name: '下载详细数据',
        icon: <IconFont iconHref='iconic_download' className={styles.downLoadIcon}/>,
        type: 'link',
      });
    }

    _permissions.map((item: any) => {
      if (item.event === 'instantFlow:cancelGaosi') {
        item.icon = <IconFont iconHref='iconmohu1' className={styles.downLoadIcon}/>;
      }
    });

    return refactorPermissions(_permissions);

  }, [detail.anaStatus, detail.permissions]);

  useEffect(() => {
    if (isNotEmptyAny(detail)) {
      methods.getTabItems();
      methods.getColumn();
      methods.getTaskDeviceList();
    }
  }, [detail]);

  const methods = useMethods({
    getColumn() {
      const dynamic: any = [
        { key: 'start', title: '时间段', width: 120, dragChecked: true, render: (_, record) => {
          return <span className={record.videoUrl && styles.timeText} onClick={() => methods.viewVideo(record.videoHash)}>{ `${record.start}-${record.end}` }</span>;
        } },
        { key: 'passbyCount', title: '过店总人数', width: 100, dragChecked: true, render: (val, record) => (record.completed ? val : '-') }
      ];
      if (detail.passbyTwoWheelVehicle) {
        dynamic.push({
          title: '二轮车总人数',
          key: 'twoWheelVehicle',
          dragChecked: true,
          width: 110,
          render: (val, record) => (record.twoWheelVehicle ? val : '-'),
        });
      }
      if (detail.shoppingCount) {
        dynamic.push({
          title: '提袋总人数',
          key: 'shoppingCount',
          dragChecked: true,
          width: 100,
          render: (val, record) => (record.shoppingCount ? val : '-'),
        });
      }
      if (detail.passbyGender) {
        dynamic.push({
          title: '性别',
          key: 'sex',
          children: [
            { key: 'passbyMale', title: '男性', width: 80, render: (val, record) => (record.completed ? val : '-') },
            { key: 'passbyFemale', title: '女性', width: 80, render: (val, record) => (record.completed ? val : '-') },
          ],
          dragChecked: true,
        });
      }
      if (detail.passbyAge) {
        dynamic.push(
          {
            title: '年龄段',
            key: 'age',
            children: [
              { key: 'passbyChild', title: '儿童', width: 80, render: (val, record) => (record.completed ? val : '-') },
              { key: 'passbyYouth', title: '青年', width: 80, render: (val, record) => (record.completed ? val : '-') },
              { key: 'passbyMiddle', title: '中年', width: 80, render: (val, record) => (record.completed ? val : '-') },
              { key: 'passbyOlder', title: '老年', width: 80, render: (val, record) => (record.completed ? val : '-') },
            ],
            dragChecked: true,
          }
        );
      }
      setDynamicColumns(dynamic);
    },
    getTaskDeviceList() {
      const api = isDemonstrate ? '/checkSpot/device/taskDeviceList/demo' : '/checkSpot/device/taskDeviceList';
      get(api, { id: detail?.id }, { proxyApi: '/blaster' }).then((res: any) => {
        setDeviceInfo(res.data || []);
        const firstName = res.data?.[0]?.name;
        const key = String(res.data?.[0]?.cameraId);
        setFilters({ ...filters, name: firstName, key: key });
        setActiveKey(key);
      });
    },
    async loadData(_params) {
      const data = deviceInfo.find((item) => String(item.cameraId) === _params.key);
      return {
        dataSource: data?.flows || [],
        count: data?.flows?.length || 0
      };
    },
    getTabItems() {
      if (detail.cameraList?.length) {
        const items: any = [];
        if (detail.cameraList.length === 1) {
          const firstName = detail.cameraList[0].name;
          items.push({ label: firstName, key: String(detail.cameraList[0].cameraId) });
        } else {
          items.push({ label: '总计', key: '0' });
          detail.cameraList.forEach((item: any) => {
            items.push({ label: item.name, key: String(item.cameraId) });
          });
        }
        setTabItems(items);
      }
    },
    changeTab(key) {
      setActiveKey(String(key));
      const name = tabItems.find((item: any) => item.key === key)?.label;
      setFilters({ ...filters, name: name, key });
    },
    viewVideo(url: string) {
      if (!url) return;
      window.open(`/imageserve/video?id=${url}`);
    },
    handleDownLoad() {
      if (isDemonstrate) {
        message.warning('演示数据暂不支持下载');
        return;
      }
      message.open({
        key: 'export',
        type: 'loading',
        content: '正在下载中...',
        duration: 0,
      });
      exportFlowData({ id: detail?.id, menuName }).then(async (res) => {
        await window.open(res.url);
        message.open({
          key: 'export',
          type: 'success',
          content: '下载成功',
          duration: 2
        });
      }).catch((err) => {
        message.open({
          key: 'export',
          type: 'error',
          content: err.msg || '获取数据失败',
          duration: 2
        });
      });
    },
    handleCancelGaosi() {
      V2Confirm({
        onSure: (modal: any) => {
          post('/checkSpot/device/cancelGaosi', { id: detail?.id }, { proxyApi: '/blaster' }).then(() => {
            message.success('取消高斯模糊成功');
            onRefresh && onRefresh();
            methods.getTaskDeviceList();
            modal.destroy();
          }).catch((err) => {
            message.error(err.msg || '取消高斯模糊失败');
          });
        },
        title: '取消高斯模糊',
        content: '此操作将使视频恢复至原始未处理状态（含人脸信息），严禁将恢复后的视频进行泄露、恶意传播或用于任何非法用途。您需对后续操作及数据安全负责，违反者将承担相应法律责任。'
      });
    }
  });

  return (
    <div className={styles.machineInfoWrap}>
      <V2Title divider type='H2' text='机位信息' className='mt-24' extra={
        // detail.anaStatus === 3 ? <button className={styles.downLoad} onClick={methods.downLoad}>
        //   <IconFont iconHref='iconic_download' className={styles.downLoadIcon}/>
        //   下载详细数据
        // </button> : <></>
        !disabled && <V2Operate
          showBtnCount={2}
          operateList={refactorPermissions(permissions)}
          onClick={(btns: { func: string | number }) => methods[btns.func]()}
        />
      }/>
      { tabItems.length > 1 && <V2Tabs className='mt-12'activeKey={activeKey} type='fullCard' items={tabItems} onChange={methods.changeTab} /> }
      { !!dynamicColumns?.length && (
        <V2Table
          className='mt-16'
          rowKey='start'
          filters={filters}
          defaultColumns={dynamicColumns}
          scroll={{ x: 'max-content', y: 460 }}
          tableSortStyle={{ // 如果存在两行的表头，就设置80px，默认是一行40px，更多以此类推}
            height: '80px',
            lineHeight: '80px'
          }}
          hideColumnPlaceholder
          type='easy'
          pagination={false}
          floorWidth={80}
          onFetch={methods.loadData}/>
      ) }
    </div>
  );
};

export default MachineInfo;
